(() => {
  if (window.timelineAnchorInit) return;
  window.timelineAnchorInit = true;

  const LINK_SELECTOR = "[data-timeline-anchor]";

  const resolveAnchorTarget = (href) => {
    if (!href || href.charAt(0) !== "#") return null;
    const rawId = href.slice(1);
    if (!rawId) return null;

    let targetId = rawId;
    try {
      targetId = decodeURIComponent(rawId);
    } catch (error) {
      targetId = rawId;
    }

    const byId =
      document.getElementById(targetId) ||
      document.getElementById(`shopify-section-${targetId}`);
    if (byId) return byId;

    let bySection = null;
    try {
      bySection = document.querySelector(`[data-section-id="${targetId}"]`);
    } catch (error) {
      bySection = null;
    }
    if (bySection) return bySection;

    if (targetId.startsWith("shopify-section-")) {
      const strippedId = targetId.replace(/^shopify-section-/, "");
      try {
        return document.querySelector(`[data-section-id="${strippedId}"]`);
      } catch (error) {
        return null;
      }
    }

    return null;
  };

  const getHeaderOffset = () => {
    const rootStyles = getComputedStyle(document.documentElement);
    const headerHeight = parseFloat(
      rootStyles.getPropertyValue("--header-height"),
    );
    if (!Number.isNaN(headerHeight)) return Math.max(0, headerHeight);

    const header = document.getElementById("Page-Header");
    if (!header) return 0;
    return Math.max(0, header.getBoundingClientRect().bottom);
  };

  const handleClick = (event) => {
    const link = event.target.closest(LINK_SELECTOR);
    if (!link) return;
    if (event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.target && link.target !== "_self") return;
    if (link.hasAttribute("download")) return;

    const href = link.getAttribute("href");
    const target = resolveAnchorTarget(href);
    if (!target) return;

    event.preventDefault();

    const headerOffset = getHeaderOffset();
    const targetTop = target.getBoundingClientRect().top + window.scrollY;
    const scrollTop = Math.max(0, targetTop - headerOffset);

    window.scrollTo({
      top: scrollTop,
      behavior: "smooth",
    });

    if (href) {
      if (history.pushState) {
        history.pushState(null, "", href);
      } else {
        window.location.hash = href;
      }
    }

    if (!target.hasAttribute("tabindex")) {
      target.setAttribute("tabindex", "-1");
      target.addEventListener(
        "blur",
        () => target.removeAttribute("tabindex"),
        { once: true },
      );
    }

    if (typeof target.focus === "function") {
      target.focus({ preventScroll: true });
    }
  };

  document.addEventListener("click", handleClick);
})();
